(function () {
  'use strict';

  const dataEl = document.getElementById('configurator-product-data');
  const root = document.querySelector('.configurator');
  if (!dataEl || !root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  let productData;
  try { productData = JSON.parse(dataEl.textContent); } catch (error) { return; }
  const variants = productData.variants || [];
  const optionsCount = Number(productData.options_count);
  const byId = (id) => document.getElementById(id);
  const panels = Array.from(root.querySelectorAll('[data-panel]'));
  const indicators = Array.from(root.querySelectorAll('[data-step]'));
  const optionInputs = Array.from(root.querySelectorAll('input[data-option-index]'));
  const designCards = Array.from(root.querySelectorAll('[data-design-name]'));
  const nameInput = byId('cfg-dedicatoria-nombre');
  const ageInput = byId('cfg-dedicatoria-edad');
  const messageInput = byId('cfg-dedicatoria-texto');
  const laterInput = byId('cfg-coordinate-later');
  const photoInput = byId('cfg-photo-input');
  const photoGrid = byId('cfg-photo-grid');
  const photoAdd = byId('cfg-photo-add-btn');
  const addButton = byId('cfg-add-to-cart');
  const dialog = byId('cfg-lightbox');
  const chooseButton = byId('cfg-lightbox-choose');
  const state = { step: 1, maxStep: 1, variant: null, design: null, photos: [], pending: false };
  const MAX_PHOTOS = 3;
  const MAX_BYTES = 5 * 1024 * 1024;
  let previewCard = null;
  let returnFocus = null;
  // Las temáticas se cargan recién al entrar al paso Diseño.
  const themeDesigns = designCards.map((card) => ({ image: card.dataset.image, card: card }));
  const themeFilters = byId('cfg-theme-filters');
  const themeRecommendations = byId('cfg-theme-recommendations');
  let themeFilter = null;
  let themesStarted = false;
  let themesReady = false;

  function message(id, text) { const el = byId(id); if (el) el.textContent = text; }
  function money(cents) {
    return '$' + (Number(cents) / 100).toLocaleString('es-UY', { maximumFractionDigits: 2 });
  }
  function safeImage(value, width) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, window.location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      // Solo el CDN de Shopify interpreta este parámetro de tamaño.
      if (width && (url.hostname === 'cdn.shopify.com' || url.pathname.startsWith('/cdn/shop/'))) {
        url.searchParams.set('width', String(width));
      }
      return url.href;
    } catch (error) { return ''; }
  }
  function normalize(value) { return String(value || '').normalize('NFC').trim().toLocaleLowerCase('es'); }
  function variantOptions(variant) {
    return variant.options || [variant.option1, variant.option2, variant.option3].slice(0, optionsCount);
  }
  function canBuyVariant() { return Boolean(state.variant && state.variant.available); }
  function personalDataComplete() {
    return laterInput.checked || (nameInput.value.trim() !== '' && (!ageInput || ageInput.value.trim() !== ''));
  }
  function syncButtons() {
    root.querySelector('[data-next="2"]').disabled = state.pending || !canBuyVariant();
    root.querySelector('[data-next="3"]').disabled = state.pending || !canBuyVariant() || !state.design;
    addButton.disabled = state.pending || !canBuyVariant() || !state.design || !personalDataComplete();
    indicators.forEach((button) => {
      const step = Number(button.dataset.step);
      button.disabled = state.pending || step > state.maxStep;
      button.classList.toggle('active', step === state.step);
      button.classList.toggle('completed', step < state.step);
      if (step === state.step) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
    });
  }
  function updateVariant() {
    const selected = Array.from({ length: optionsCount }, (_, index) => {
      const input = optionInputs.find((radio) => Number(radio.dataset.optionIndex) === index && radio.checked);
      return input ? input.value : null;
    });
    // Nunca conservar la variante anterior si la combinación dejó de existir.
    state.variant = variants.find((variant) => variantOptions(variant).length === optionsCount &&
      variantOptions(variant).every((value, index) => value === selected[index])) || null;
    message('cfg-variant-status', !state.variant ? 'Esta combinación no está disponible. Elegí otra opción.' :
      (!state.variant.available ? 'Esta combinación está agotada. Elegí otra opción para continuar.' : 'Elegiste ' + variantOptions(state.variant).join(' · ') + ' · ' + money(state.variant.price)));
    message('cfg-header-price', state.variant ? money(state.variant.price) : 'Combinación no disponible');
    const from = root.querySelector('.cfgx-desde');
    if (from) from.hidden = true;
    syncButtons();
  }
  function validatePersonalData() {
    const valid = personalDataComplete();
    message('cfg-personalization-error', valid ? '' : 'Completá el nombre' + (ageInput ? ' y la edad' : '') + ', o elegí «Lo coordinamos después».');
    [nameInput, ageInput].filter(Boolean).forEach((input) => {
      input.setAttribute('aria-invalid', String(!laterInput.checked && !input.value.trim()));
    });
    if (!valid) (nameInput.value.trim() ? ageInput : nameInput).focus();
    return valid;
  }
  function showStep(step, focus) {
    state.step = step;
    state.maxStep = Math.max(state.maxStep, step);
    panels.forEach((panel) => {
      const active = Number(panel.dataset.panel) === step;
      panel.hidden = !active;
      panel.classList.toggle('active', active);
    });
    if (step === 2) initializeThemes();
    if (step === 4) populateSummary();
    syncButtons();
    if (focus) revealStep(step, false);
  }
  // Lleva la vista y el foco al título del paso. Descuenta la cabecera fija, que al subir
  // reaparece y antes tapaba el título.
  function revealStep(step, instant) {
    const heading = root.querySelector('[data-panel="' + step + '"] h2');
    heading.tabIndex = -1;
    heading.focus({ preventScroll: true });
    const header = document.querySelector('.section-header');
    const sticky = header && window.getComputedStyle(header).position === 'sticky';
    const offset = (sticky ? header.offsetHeight : 0) + 24;
    const smooth = !instant && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, window.scrollY + heading.getBoundingClientRect().top - offset), behavior: smooth ? 'smooth' : 'auto' });
  }
  // Al cerrarse el visor, v2-atras-cierra.js retira su entrada del historial con history.back() y el
  // navegador restaura el scroll anterior justo después del popstate. Lo que tenga que mover la
  // vista se hace cuando eso terminó (o enseguida, si no había entrada que retirar).
  function afterOverlayCloses(run) {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      window.removeEventListener('popstate', onPop);
      run();
    };
    const onPop = () => window.requestAnimationFrame(() => window.requestAnimationFrame(finish));
    window.addEventListener('popstate', onPop);
    window.setTimeout(finish, 400);
  }
  function navigate(step) {
    if (state.pending) return;
    if (step > 1 && !canBuyVariant()) { showStep(1, true); return; }
    if (step > 2 && !state.design) { showStep(2, true); return; }
    if (step > 3 && !personalDataComplete()) { showStep(3, true); validatePersonalData(); return; }
    showStep(step, true);
  }
  root.querySelectorAll('[data-next], [data-prev], [data-step]').forEach((button) => {
    button.addEventListener('click', () => navigate(Number(button.dataset.next || button.dataset.prev || button.dataset.step)));
  });
  optionInputs.forEach((input) => input.addEventListener('change', updateVariant));

  function updateThemeRecommendations() {
    if (!themesReady || !themeRecommendations || !state.design) return;
    window.tmTemas.renderRecommendations(themeRecommendations, {
      url: state.design.image,
      handle: productData.product_handle,
      theme: themeFilter ? themeFilter.theme : ''
    });
  }
  function applyThemeFilter() {
    if (!themeFilter) return;
    let visible = 0;
    themeDesigns.forEach((design) => {
      design.card.hidden = !themeFilter.filter(design);
      if (!design.card.hidden) visible += 1;
    });
    byId('cfg-theme-empty').hidden = visible > 0 || !themeFilter.theme;
    // Filtrar sólo cambia la grilla; la selección, variante y personalización siguen intactas.
    updateThemeRecommendations();
  }
  function initializeThemes() {
    if (themesStarted || !themeFilters || !window.tmTemas) return;
    themesStarted = true;
    window.tmTemas.load().then(() => {
      themeFilter = window.tmTemas.mountFilters(themeFilters, {
        designs: themeDesigns,
        initialTheme: new URLSearchParams(window.location.search).get('tema') || '',
        onChange: applyThemeFilter
      });
      themesReady = true;
      applyThemeFilter();
    }).catch(() => {
      // Si falla la taxonomía, sigue disponible la selección de diseños habitual.
      themeFilter = null;
      themesReady = false;
      themeFilters.replaceChildren();
      themeFilters.hidden = true;
      byId('cfg-theme-empty').hidden = true;
      themeDesigns.forEach((design) => { design.card.hidden = false; });
      if (themeRecommendations) { themeRecommendations.replaceChildren(); themeRecommendations.hidden = true; }
    });
  }
  function selectDesign(card) {
    const image = safeImage(card.dataset.image, 1600);
    if (!image) { message('cfg-design-status', 'No pudimos cargar este diseño. Elegí otro o consultanos.'); return; }
    state.design = { id: card.dataset.designId, name: card.dataset.designName, image: image, card: card };
    designCards.forEach((item) => {
      const selected = item === card;
      item.setAttribute('aria-pressed', String(selected));
      item.querySelector('.cfgx-view-label').textContent = selected ? 'Elegido ✓ · Ampliar' : 'Ampliar diseño';
    });
    message('cfg-design-status', '');
    message('cfg-current-design', 'Tu diseño: ' + state.design.name);
    byId('cfg-selected-design').hidden = false;
    updateThemeRecommendations();
    const hero = byId('cfg-hero-img');
    if (hero) { hero.src = safeImage(image, 800); hero.removeAttribute('srcset'); hero.alt = state.design.name; }
    root.querySelectorAll('.cfgx-thumb').forEach((thumb) => thumb.classList.remove('is-active'));
    syncButtons();
  }
  function openPreview(src, title, card, trigger) {
    if (state.pending || !safeImage(src)) return;
    previewCard = card;
    returnFocus = trigger;
    message('cfg-lightbox-title', title);
    byId('cfg-lightbox-img').src = safeImage(src, 1600);
    byId('cfg-lightbox-img').alt = title;
    chooseButton.hidden = !card;
    dialog.showModal();
    byId('cfg-lightbox-close').focus();
  }
  byId('cfg-lightbox-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { if (returnFocus && returnFocus.isConnected) returnFocus.focus(); });
  chooseButton.addEventListener('click', () => {
    const card = previewCard;
    if (card) selectDesign(card);
    const chosen = Boolean(card && state.design && state.design.card === card);
    // Boris, 12/10: al elegir desde la foto ampliada se sigue al paso siguiente (los datos),
    // en vez de volver a la grilla de diseños. El foco va al nuevo paso, no a la tarjeta.
    if (chosen) returnFocus = null;
    dialog.close();
    if (!chosen || state.pending || !canBuyVariant()) return;
    showStep(3, false);
    afterOverlayCloses(() => { if (state.step === 3) revealStep(3, true); });
  });
  designCards.forEach((card) => {
    const img = card.querySelector('img[data-design-src]');
    if (img) {
      const src = safeImage(img.dataset.designSrc, 400);
      if (src) { img.src = src; img.srcset = safeImage(src, 200) + ' 200w, ' + src + ' 400w'; img.sizes = '(min-width: 750px) 220px, 45vw'; }
    }
    card.addEventListener('click', () => openPreview(card.dataset.image, card.dataset.designName, card, card));
  });
  byId('cfg-hero-image').addEventListener('click', function () {
    const img = byId('cfg-hero-img'); if (img) openPreview(img.src, img.alt, null, this);
  });
  byId('cfg-selected-zoom').addEventListener('click', function () {
    if (state.design) openPreview(state.design.image, state.design.name, null, this);
  });
  byId('cfg-change-design').addEventListener('click', () => {
    const card = designCards.find((item) => !item.hidden);
    if (card) {
      card.focus({ preventScroll: true });
      card.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    } else if (themeFilter) {
      themeFilter.setTheme('');
      const first = designCards[0];
      if (first) first.focus();
    }
  });
  byId('cfg-clear-theme').addEventListener('click', () => {
    if (themeFilter) themeFilter.setTheme('');
    const first = themeFilters.querySelector('button');
    if (first) first.focus();
  });
  byId('cfg-summary-zoom').addEventListener('click', function () {
    if (state.design) openPreview(state.design.image, state.design.name, null, this);
  });
  root.querySelectorAll('.cfgx-thumb').forEach((thumb) => thumb.addEventListener('click', () => {
    const img = byId('cfg-hero-img'); if (!img) return;
    img.src = thumb.dataset.src; img.removeAttribute('srcset'); img.alt = productData.product_title;
    root.querySelectorAll('.cfgx-thumb').forEach((item) => item.classList.toggle('is-active', item === thumb));
  }));

  [nameInput, ageInput, messageInput].filter(Boolean).forEach((input) => input.addEventListener('input', () => {
    message('cfg-char-count', String(messageInput.value.length));
    input.removeAttribute('aria-invalid');
    if (personalDataComplete()) message('cfg-personalization-error', '');
    syncButtons();
  }));
  laterInput.addEventListener('change', () => {
    [nameInput, ageInput].filter(Boolean).forEach((input) => {
      input.disabled = laterInput.checked;
      input.required = !laterInput.checked;
      input.removeAttribute('aria-invalid');
    });
    message('cfg-personalization-error', '');
    syncButtons();
  });

  photoAdd.addEventListener('click', () => photoInput.click());
  photoInput.addEventListener('change', () => {
    const errors = [];
    Array.from(photoInput.files || []).forEach((file) => {
      if (state.photos.length >= MAX_PHOTOS) { errors.push('Podés adjuntar hasta 3 fotos.'); return; }
      if (!['image/jpeg', 'image/png'].includes(file.type)) { errors.push(file.name + ': usá una foto JPG o PNG.'); return; }
      if (file.size > MAX_BYTES || file.size === 0) { errors.push(file.name + ': el archivo debe pesar hasta 5 MB y no estar vacío.'); return; }
      state.photos.push({ file: file, preview: URL.createObjectURL(file) });
    });
    photoInput.value = '';
    message('cfg-photo-status', Array.from(new Set(errors)).join(' '));
    renderPhotos();
  });
  function renderPhotos() {
    photoGrid.querySelectorAll('.configurator__photo-preview').forEach((element) => element.remove());
    state.photos.forEach((photo, index) => {
      const preview = document.createElement('div'); preview.className = 'configurator__photo-preview';
      const img = document.createElement('img'); img.src = photo.preview; img.alt = 'Foto ' + (index + 1); img.width = 160; img.height = 160;
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'configurator__photo-remove';
      remove.textContent = '×'; remove.setAttribute('aria-label', 'Quitar foto ' + (index + 1));
      remove.addEventListener('click', () => {
        if (state.pending) return;
        URL.revokeObjectURL(photo.preview); state.photos.splice(index, 1); renderPhotos(); photoAdd.focus();
      });
      preview.append(img, remove); photoGrid.insertBefore(preview, photoAdd);
    });
    photoAdd.hidden = state.photos.length >= MAX_PHOTOS;
  }
  function populateSummary() {
    message('cfg-summary-size', state.variant ? variantOptions(state.variant).join(' · ') : '-');
    message('cfg-summary-design', state.design ? state.design.name : '-');
    message('cfg-summary-price', state.variant ? money(state.variant.price) : '-');
    const rows = [
      ['name', nameInput.value.trim()], ['age', ageInput ? ageInput.value.trim() : ''],
      ['message', messageInput.value.trim()], ['photos', state.photos.length ? state.photos.length + (state.photos.length === 1 ? ' foto adjunta' : ' fotos adjuntas') : '']
    ];
    rows.forEach(([key, value]) => {
      const row = byId('cfg-summary-' + key + '-row'); row.style.display = ''; row.hidden = !value;
      message('cfg-summary-' + key, value);
    });
    byId('cfg-summary-later-row').hidden = !laterInput.checked;
    const img = byId('cfg-summary-image'); img.hidden = !state.design;
    if (state.design) { img.src = safeImage(state.design.image, 800); img.alt = state.design.name; }
  }
  function properties() {
    const result = { 'Diseño': state.design.name, '_diseño_imgs': state.design.image };
    if (nameInput.value.trim()) result.Nombre = nameInput.value.trim();
    if (ageInput && ageInput.value.trim()) result.Edad = ageInput.value.trim();
    if (messageInput.value.trim()) result.Mensaje = messageInput.value.trim();
    if (laterInput.checked) result['Personalización'] = 'Lo coordinamos después';
    return result;
  }
  // La compresión conserva PNG con transparencia y vuelve al original si no puede reducirlo.
  function compressImage(file) {
    return new Promise((resolve) => {
      let url;
      const finish = (result) => { if (url) URL.revokeObjectURL(url); resolve(result); };
      try {
        const img = new Image(); url = URL.createObjectURL(file);
        img.onerror = () => finish(file);
        img.onload = () => {
          try {
            const scale = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
            const canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
            canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
            const ctx = canvas.getContext('2d'); if (!ctx) { finish(file); return; }
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.toBlob((blob) => {
              if (!blob || blob.size >= file.size) { finish(file); return; }
              finish(new File([blob], file.name, { type: file.type }));
            }, file.type, 0.85);
          } catch (error) { finish(file); }
        };
        img.src = url;
      } catch (error) { finish(file); }
    });
  }
  function cartError(error) {
    const detail = error instanceof TypeError ? 'Revisá tu conexión y volvé a intentar.' :
      (error && error.message ? error.message : 'Volvé a intentar.');
    const text = 'No pudimos agregarlo al carrito. ' + detail;
    message('cfg-cart-error', text);
    message('cfg-cart-status', '');
    document.dispatchEvent(new CustomEvent('tematik:cart:error', { detail: { source: 'configurator', message: text } }));
  }
  addButton.addEventListener('click', async () => {
    if (state.pending) return;
    updateVariant();
    if (!canBuyVariant() || !state.design || !personalDataComplete()) { navigate(4); return; }
    const variant = state.variant;
    const lineProperties = properties();
    const photos = state.photos.slice();
    state.pending = true;
    syncButtons();
    addButton.textContent = 'Agregando…';
    addButton.setAttribute('aria-busy', 'true');
    message('cfg-cart-error', '');
    message('cfg-cart-status', 'Agregando tu producto al carrito…');
    let confirmed = false;
    try {
      const headers = { Accept: 'application/json' };
      let body;
      if (photos.length) {
        const files = await Promise.all(photos.map((photo) => compressImage(photo.file)));
        body = new FormData(); body.append('id', String(variant.id)); body.append('quantity', '1');
        Object.entries(lineProperties).forEach(([key, value]) => body.append('properties[' + key + ']', value));
        files.forEach((file, index) => body.append('properties[Foto ' + (index + 1) + ']', file, file.name));
      } else {
        headers['Content-Type'] = 'application/json';
        body = JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: lineProperties }] });
      }
      const response = await fetch(productData.cart_add_url || '/cart/add.js', { method: 'POST', headers: headers, body: body });
      const result = await response.json().catch(() => null);
      if (!response.ok || (result && result.status)) {
        throw new Error(result && typeof (result.description || result.message) === 'string' ? (result.description || result.message) : 'Shopify no pudo agregar el producto. Volvé a intentar.');
      }
      const added = result && (Array.isArray(result.items) ? result.items[0] : result);
      if (!added || String(added.variant_id || added.id) !== String(variant.id) || !(Number(added.quantity) > 0)) {
        throw new Error('No recibimos una confirmación válida. Revisá el carrito antes de reintentar.');
      }
      confirmed = true;
      const returnedPrice = typeof added.final_price === 'number' ? added.final_price : added.price;
      const price = Number.isFinite(returnedPrice) && returnedPrice >= 0 ? returnedPrice / 100 : variant.price / 100;
      message('cfg-cart-status', 'Agregado al carrito ✓');
      addButton.textContent = 'Agregado al carrito ✓';
      // Un solo evento después de la confirmación, también cuando se adjuntaron fotos.
      document.dispatchEvent(new CustomEvent('tematik:cart:added', { detail: {
        source: 'configurator', items: [{ variant_id: variant.id, product_title: added.product_title || productData.product_title, price: price, quantity: 1 }],
        value: price, currency: 'UYU'
      } }));
    } catch (error) {
      cartError(error);
    } finally {
      addButton.removeAttribute('aria-busy');
      if (!confirmed) { state.pending = false; addButton.textContent = 'Agregar al carrito'; syncButtons(); }
    }
    if (confirmed) window.location.assign(productData.cart_url || '/cart');
  });

  // Respetar una variante de URL válida; en el resto de los casos, la primera disponible.
  const params = new URLSearchParams(window.location.search);
  const requestedVariant = variants.find((variant) => String(variant.id) === params.get('variant'));
  const initialVariant = requestedVariant || variants.find((variant) => variant.available) || variants[0];
  if (initialVariant) {
    optionInputs.forEach((input) => { input.checked = input.value === variantOptions(initialVariant)[Number(input.dataset.optionIndex)]; });
  }
  updateVariant();
  showStep(1, false);
  const requestedDesign = params.get('diseno');
  if (requestedDesign) {
    const card = designCards.find((item) => item.dataset.designId === requestedDesign) ||
      designCards.find((item) => normalize(item.dataset.designName) === normalize(requestedDesign));
    if (card) {
      selectDesign(card);
      if (state.design) showStep(2, true);
      if (!canBuyVariant()) message('cfg-design-status', 'Diseño elegido: ' + card.dataset.designName + '. Volvé a Medida para revisar la disponibilidad.');
    } else {
      message('cfg-design-status', 'El diseño del enlace no está en la lista de este producto. Elegí uno de los disponibles.');
    }
  }

  // Enlace de WhatsApp (12/10): medida y diseño van en la URL; la dedicatoria, después del «#»
  // (no llega a servidores ni analítica). Al abrir el enlace se completa sola.
  const CAMPOS_DEDICATORIA = [['nombre', nameInput], ['edad', ageInput], ['mensaje', messageInput]];
  try {
    const guardado = new URLSearchParams(window.location.hash.slice(1));
    CAMPOS_DEDICATORIA.forEach(([clave, input]) => {
      const valor = guardado.get(clave);
      if (input && valor) { input.value = valor; input.dispatchEvent(new Event('input', { bubbles: true })); }
    });
  } catch (error) { /* un enlace incompleto no bloquea el configurador */ }
  (window.tmEnlaceWA = window.tmEnlaceWA || { proveedores: [] }).proveedores.push(() => {
    const url = new URL(window.location.origin + window.location.pathname);
    if (state.variant) url.searchParams.set('variant', state.variant.id);
    if (state.design) url.searchParams.set('diseno', state.design.id);
    const datos = new URLSearchParams();
    CAMPOS_DEDICATORIA.forEach(([clave, input]) => { if (input && input.value.trim()) datos.set(clave, input.value.trim()); });
    return url.href + (datos.toString() ? '#' + datos.toString() : '');
  });
})();
